import React from 'react';
import {
    useSsDispatch as useDispatch,
    useSsSelector as useSelector,
} from '~SpectateStore';
import { useTranslation } from 'react-i18next';

import {
    selectBets,
} from '~Betslip/selectors/betReceiptSelectors';

import {
    goBackToBetslip,
} from '~Betslip/slices/betReceiptSlice';

import BetsSection from './BetsSection';
import Recommendations from '../Recommendations';

import './styles.scss';

const BetReceipt = () => {
    const [ t ] = useTranslation();
    const dispatch = useDispatch();

    const bets = useSelector(selectBets);
    const hasAnyFails = bets.some(bet => !bet.success);
    const hasAnySuccess = bets.some(bet => bet.success);

    const clickHandler = () => {
        dispatch(goBackToBetslip());
    };

    const BackToBetslip = () => {
        return (
            <div className="fullslip__back-button-container">
                <div
                    className="fullslip__back-button"
                    onClick={clickHandler}
                    data-spectate-product="betreceipt;back-to-betslip"
                >
                    {t('betslip.back_to_betslip')}
                </div>
            </div>
        );
    };

    return (
        <>
            <div className="fullslip__content">
                {
                    hasAnySuccess
                    ?
                        <div className="fullslip__placed-message">
                            <i className="fullslip__success-icon"></i>
                            <span>{t('betslip.bet_placed')}</span>
                        </div>
                    : null
                }
                <div className="fullslip__bets-section">
                    <BetsSection bets={bets}/>
                    {
                        hasAnyFails
                        ? <BackToBetslip />
                        : null
                    }
                </div>
                <Recommendations />
            </div>

            <div className="fullslip__toBottom"></div>
        </>
    );
};

export default BetReceipt;
